import { render } from "./MainSidebarItem.vue?vue&type=template&id=5d4035a1"
import script from "./MainSidebarItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MainSidebarItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/layout/MainSidebarItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d4035a1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d4035a1', __exports__)) {
    api.reload('5d4035a1', __exports__)
  }
  
  module.hot.accept("./MainSidebarItem.vue?vue&type=template&id=5d4035a1", () => {
    api.rerender('5d4035a1', render)
  })

}


export default __exports__